import React, { Component } from "react";
import {
  PieChart,
  Pie,
  Tooltip,
  Cell,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { UAParser } from "ua-parser-js";
import themeLarge from "../../component/ThemeLarge";

class UserAgentStats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      browserData: [],
      osData: [],
      colors: [
        "#1976d2",
        "#f57c00",
        "#388e3c",
        "#d32f2f",
        "#7b1fa2",
        "#df0898ff",
        "#ba4a77ff",
        "#5d4037",
      ],
    };
  }

  componentDidMount() {
    this.parseUserAgents(this.props.vitals || []);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.vitals !== this.props.vitals) {
      this.parseUserAgents(this.props.vitals || []);
    }
  }

  parseUserAgents = (vitals) => {
    const browserCount = {};
    const osCount = {};
    const parser = new UAParser();

    vitals.forEach((entry) => {
      if (!entry.userAgent) return;

      parser.setUA(entry.userAgent);
      const browser = parser.getBrowser().name || "Unknown";
      const os = parser.getOS().name || "Unknown";

      browserCount[browser] = (browserCount[browser] || 0) + 1;
      osCount[os] = (osCount[os] || 0) + 1;
    });

    const browserData = Object.entries(browserCount).map(([name, value]) => ({
      name,
      value,
    }));

    const osData = Object.entries(osCount).map(([name, value]) => ({
      name,
      value,
    }));

    this.setState({ browserData, osData });
  };

  renderPieChart = (data, title) => {
    const { colors } = this.state;

    return (
      <div className="col-md-6 mb-4">
        <h6 style={{ color: themeLarge.colors.primary }}>{title}</h6>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={100}
              fill="#8884d8"
              label
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index % colors.length]}
                />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
    );
  };

  render() {
    const { browserData, osData } = this.state;

    return (
      <div className="mt-5" style={{ fontFamily: "Kumbh Sans" }}>
        <h5 style={{ color: themeLarge.colors.primary }}>
          🧪 User Agent Statistics
        </h5>
        <p style={{ fontSize: "0.9rem" }}>
          Breakdown of browsers and operating systems from the last 500 reports.
        </p>

        <div className="row">
          {this.renderPieChart(browserData, "Browser Usage")}
          {this.renderPieChart(osData, "Operating System")}
        </div>
      </div>
    );
  }
}

export default UserAgentStats;
